import { PlusIcon } from '@radix-ui/react-icons';
import { IconButton } from '@radix-ui/themes';
import { DropdownMenu } from '@/components/shared/dropdown-menu';
import type { DropdownMenuProps } from '@/components/shared/dropdown-menu';
import { AiFolderIcon } from '@/v2/assets/icons/AiFolderIcon';
import { CheckmarkBadgeIcon } from '@/v2/assets/icons/CheckmarkBadgeIcon';
import {SnippetIcon} from "@/v2/assets/icons/SnippetIcon";

interface AddSnippetCollectionDropdownProps {
  onAddSnippet: () => void;
  onAddCollection: () => void;
}

export function AddSnippetCollectionDropdown({
  onAddSnippet,
  onAddCollection,
}: AddSnippetCollectionDropdownProps) {
  const dropdownMenuItems: DropdownMenuProps['items'] = [
      {
          label: 'Snippet',
          onClick: onAddSnippet,
          icon: <AiFolderIcon size={12} fill="currentColor" />,
      },
      {
          label: 'Collection',
          onClick: onAddCollection,
          icon: <SnippetIcon size={12} fill="currentColor" />,
      }
      ]


  return (
    <DropdownMenu items={dropdownMenuItems} align="end">
      <DropdownMenu.Trigger>
        <IconButton
          variant="ghost"
          size="1"
          aria-label="Add snippet or collection"
        >
          <PlusIcon width={16} height={16} />
        </IconButton>
      </DropdownMenu.Trigger>
    </DropdownMenu>
  );
}
